/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eleven_Labs_Logo_AltInputs */



/**
* | output |
* | --- |
* | "Eleven Labs logo" |
*
* @param {Eleven_Labs_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const eleven_labs_logo_alt = /** @type {((inputs?: Eleven_Labs_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eleven_Labs_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Logo Eleven Labs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eleven Labs Logo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Logo di Eleven Labs")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Логотип Eleven Labs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Logotipo de Eleven Labs")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Eleven Labs 的标志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イレブンラボのロゴ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इलेवन लैब्स लोगो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Logotipo da Eleven Labs")
	return /** @type {LocalizedString} */ ("Eleven Labs logo")
});